export const colors = {
  primary: "#2b6cb0",
  secondary: "#3182ce",
  background: "#ebf8ff",
  white: "#fff",
  success: "#75F2BE",
};
